import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAccountsClient } from 'services/api';
import { DeleteLinkedSaudiRewardsAccountDocument } from 'types/api/account.types';

import { accountQuery } from './queries';

export const useDeleteSaudiRewardsAccount = () => {
  const accountClient = useAccountsClient();
  const queryClient = useQueryClient();

  const { isPending, isPaused, isError, mutate } = useMutation({
    mutationFn: () =>
      accountClient.request(DeleteLinkedSaudiRewardsAccountDocument),
    onSuccess: () => {
      queryClient.setQueryData(accountQuery.queryKey, (oldData) => {
        if (!!oldData) {
          return {
            account: {
              ...oldData.account,
              saudiRewardsMemberId: undefined,
            },
          };
        }
      });
      queryClient.invalidateQueries({ queryKey: accountQuery.queryKey });
    },
  });

  return {
    deleteLinkedSaudiRewardsAccount: mutate,
    isLoading: isPending && !isPaused,
    isError,
  };
};
